import * as Common from '../../common/common'
import axios from "axios";
import videojs from "video.js"
import $ from 'jquery';
window.jQuery = $
window.$ = $

let cctvArray = [];
let video;

window.addEventListener('DOMContentLoaded', (event) => {
	cctvData();
});

async function cctvData() {
	showLoading();
	try {
		const response = await Common.axiosApi.post("/admin/CctvInfo");
		let list = response;
		list = list.filter(v => v.hpdspcd === "1001" && v.usecd === "1001");

		cctvTable(list);
		leftContent(list);
	} catch(error) {
		console.log("Error in cctvData : ", error);
	} finally {
		hideLoading();
	}
}

// 오른쪽 테이블 세팅
function cctvTable(info) {
	cctvArray = info;
	
	// 이름순으로 정렬
	cctvArray.sort(function(a, b) {
		if (a.cctvcd.toLowerCase() < b.cctvcd.toLowerCase()) return -1;
		if (a.cctvcd.toLowerCase() > b.cctvcd.toLowerCase()) return 1;
		return 0;
	});
	
	let tbody = document.getElementById("cctvTbody");
	let html = "";
	cctvArray.forEach(info => {
		html += "<tr>";
		html += "	<td class='pointer'>" + info.cctvnm + "</td>";
		html += "</tr>";
	})

	tbody.innerHTML = html;
}

// 왼쪽 상단 세팅
function leftContent(info) {
	let st = "";
	let tbody = document.getElementById("cctvTbody");
	let nowTime = document.getElementById("lsttm");
	
	const urlSearch = new URLSearchParams(location.search);
	const urlObscd = urlSearch.get('obscd');

	// 쿼리스트링에 obscd가 있을 경우
	if (urlObscd != null) {
	    for (const infoItem of info) {
	        if (infoItem.cctvcd === urlObscd) {
	            let stationId = document.getElementById("stationId");
	            stationId.textContent = infoItem.cctvnm;
	            setVideo(infoItem.url)
	            break;
	        }
	    }
	//맨 처음 로드 할때 값
	} else {
	    let stationId = document.getElementById("stationId");
	    stationId.textContent = info[0].cctvnm;
	    setVideo(info[0].url);
	}

	// 클릭 했을때
	for (let i = 0; i < tbody.rows.length; i++) {
		tbody.rows[i].addEventListener("click", function() {
			st = info[i].cctvnm;
			stationId.textContent = st;
			
			setVideo(info[i].url);
		})
	}

	// 날짜 세팅
	let now = new Date();
	let year = now.getFullYear();
	let month = now.getMonth() + 1;
	let date = now.getDate();
	let hour = now.getHours();
	let min = now.getMinutes();

	month = (month < 10) ? "0" + month : month;
	date = (date < 10) ? "0" + date : date;
	hour = (hour < 10) ? "0" + hour : hour;
	min = (min < 10) ? "0" + min : min;
	
	// 현재 시간 값 세팅
	let timeSet = year + "-" + month + "-" + date + " " + hour + ":" + min
	nowTime.textContent = timeSet;
}

// 비디오 세팅
const setVideo = function(url) {
	document.getElementById("loading").style.display = 'block';
	
	if (video) {
		// 플레이어 삭제하고, Video 변수 초기화
		video.destroy();
		video = null;
		
		// canvas 태그도 삭제 후 재생성
		const videoCanvasContainer = document.getElementById("video");
		const oldCanvas = document.getElementById("video-canvas");
		videoCanvasContainer.removeChild(oldCanvas);
		const newCanvas = document.createElement("canvas");
		newCanvas.id = "video-canvas";
		newCanvas.style.zIndex = '1';
		videoCanvasContainer.appendChild(newCanvas);
	}
	
    var canvas = document.getElementById('video-canvas');
    video = new JSMpeg.Player(url, {
        canvas: canvas,
        autoplay: true,
        onSourceEstablished : function (player) { // 동영상 첫 번째 프레임 받을 시 로딩 숨기기
            document.getElementById('loading').style.display = 'none';
        }
    });
}

